(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('HospitalizationTypeParentDialogController', HospitalizationTypeParentDialogController);

    HospitalizationTypeParentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'HospitalizationTypeParent'];

    function HospitalizationTypeParentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, HospitalizationTypeParent) {
        var vm = this;
        vm.hospitalizationTypeParent = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:hospitalizationTypeParentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.hospitalizationTypeParent.id !== null) {
                HospitalizationTypeParent.update(vm.hospitalizationTypeParent, onSaveSuccess, onSaveError);
            } else {
                HospitalizationTypeParent.save(vm.hospitalizationTypeParent, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
